module.exports = __webpack_public_path__ + "images/117_320.jpg";